import formatMoney from "../../../../../utils/formatMoney";

export default function DocumentLine({ item }: any) {
  return (
    <div className="grid grid-cols-12 border-t border-black items-center text-gray-700">
      <div className="col-span-5 p-2 border-r border-black  text-left flex-1">
        {item?.code} {item?.description}
      </div>
      <div className="col-span-1 p-2 border-r border-black  text-center">
        {item?.quantity}
      </div>
      <div className="col-span-2 p-2  border-r border-black truncate">
        {formatMoney(item?.unit_price * 0.82)}
      </div>
      <div className="col-span-2 p-2 border-r border-black  text-right">
        {item?.unit_measure}
      </div>
      <div className="col-span-2 p-2 text-right">
        {formatMoney(item?.net_total * 0.82)}
      </div>
    </div>
  );
}
